import { render, staticRenderFns } from "./mainSearchBar.vue?vue&type=template&id=58daa47b&scoped=true&"
import script from "./mainSearchBar.vue?vue&type=script&lang=js&"
export * from "./mainSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./mainSearchBar.vue?vue&type=style&index=0&id=58daa47b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58daa47b",
  null
  
)

export default component.exports